import { IDjangoApi1License } from '../../tn.common';

export function hasLicenseType(
    licenses: IDjangoApi1License[],
    type: string
): IDjangoApi1License[] {
    return licenses.filter((license) => {
        return license.fontRights[type] && license.fontRights[type].qty;
    });
}

export function hasLicenseTypeFilter(): (
    licenses: IDjangoApi1License[],
    type: string
) => IDjangoApi1License[] {
    return hasLicenseType;
}
